export default {
    PERIODS: {
        SEEDLING: '#f3c518',
        PLANTING: '#136a4a',
        HARVEST: '#a4de56',
    },
    GROWING_STEPS: ['#FFEB3B', '#F8E238', '#F1E442', '#E6E64C', '#D4E856', '#C2E860', '#A4E663', '#86E266', '#68DD69', '#4AD66D', '#2ECC71'] // FROM YELLOW TO GREEN
};
